module.exports = __webpack_public_path__ + "static/media/38_B.3f7bf20c.png";